export default __webpack_public_path__ + "static/access-map-en-187ad2021b927838babfdf69138d7cb1.jpg";